"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalNavigation_component_exports = {};
__export(GlobalNavigation_component_exports, {
  GlobalNavigation: () => GlobalNavigation
});
module.exports = __toCommonJS(GlobalNavigation_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_AvatarPopup = require("@greatmindsorg/gmui-lib/dist/components/AvatarPopup/AvatarPopup.component");
var import_Select = require("@greatmindsorg/gmui-lib/dist/components/Select/Select.component");
var import_GlobalNavigationLogo = require("./GlobalNavigationLogo/GlobalNavigationLogo.component");
var import_CompoundComponent = require("./CompoundComponent.helper");
var import_LinkTabs = require("./LinkTabs/LinkTabs.component");
var import_SkipToContent = __toESM(require("./SkipToContent/SkipToContent.component"));
const GlobalNavigation = ({
  children,
  mainContentId
}) => {
  import_GlobalNavigationLogo.GlobalNavigationLogo.displayName = "GlobalNavigationLogo";
  import_Select.Select.displayName = "GlobalNavigationSelect";
  import_LinkTabs.LinkTabs.displayName = "GlobalNavigationLinkTabs";
  import_AvatarPopup.AvatarPopup.displayName = "GlobalNavigationAvatarPopup";
  const elements = (0, import_react.useMemo)(
    () => (0, import_CompoundComponent.ChildrenComponents)(children).groupByDisplayName([
      import_GlobalNavigationLogo.GlobalNavigationLogo.displayName,
      import_Select.Select.displayName,
      import_LinkTabs.LinkTabs.displayName,
      import_AvatarPopup.AvatarPopup.displayName
    ]),
    [children]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("header", { className: "z-40 h-16 border-0 border-b border-solid border-neutral100 bg-white", children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "flex h-full flex-row items-center justify-between px-4", children: [
    mainContentId && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_SkipToContent.default, { targetId: mainContentId, text: "Skip to content" }),
    elements[import_GlobalNavigationLogo.GlobalNavigationLogo.displayName],
    elements[import_Select.Select.displayName],
    elements[import_LinkTabs.LinkTabs.displayName],
    elements.children,
    elements[import_AvatarPopup.AvatarPopup.displayName]
  ] }) });
};
GlobalNavigation.Logo = import_GlobalNavigationLogo.GlobalNavigationLogo;
GlobalNavigation.Select = import_Select.Select;
GlobalNavigation.LinkTabs = import_LinkTabs.LinkTabs;
GlobalNavigation.AvatarPopup = import_AvatarPopup.AvatarPopup;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalNavigation
});
//# sourceMappingURL=GlobalNavigation.component.js.map